import Imgix from 'react-imgix';
import Quantity from './quantity';
import ProductPriceFormat from '../../../../../products/product-price/product-price-format';
import React from 'react';
import { ICartItem } from '../../../interfaces';
import CartItemTitle from './cart-item-title';
import CartItemNotification from './cart-item-notification';
import CartItemPromos from './cart-item-promos';
import RemoveCartItemBtn from './remove-cart-item-btn';
import EnableDisableCheckbox from './enable-disable-cb';
import CartComment from './cart-comment';

interface IStep1CartItemMobile {
    cartItem: ICartItem,
    isLastItem: boolean,
}

const Step1CartItemMobile = (props: IStep1CartItemMobile) => {

    const cartItem = props.cartItem;
    const itemPriceData = cartItem.priceData;

    return (
        <>
            <div className="flex justify-around py-4 mx-4">
                <div className="w-28 mr-4">
                    <div>
                        <EnableDisableCheckbox cartItem={ cartItem } />
                    </div>
                    <div className="bg-gray-100 p-4 flex items-center justify-center">

                        <Imgix
                            className="lazyload"
                            src={ cartItem.skuThumb }
                            width={ 60 }
                            attributeConfig={{
                                src: 'data-src',
                                srcSet: 'data-srcset',
                                sizes: 'data-sizes',
                            }}
                            htmlAttributes={{
                                alt: `Image for ${ cartItem.skuName }`
                            }}
                        />
                    </div>

                    { cartItem.isSaveForLater && <button type="button" className="text-gray-500 text-sm mt-4">Save for Later</button> }
                    <RemoveCartItemBtn cartItem={ cartItem } classes="text-gray-500 text-sm" />
                </div>

                <div>
                    <CartItemTitle cartItem={ cartItem } classes="text-tiny text-gray-700 font-bold mb-2" />

                    { cartItem.cartNotification && <CartItemNotification cartItem={ cartItem } classes="text-sm" /> }
                    { cartItem.cartComment && <CartComment comment={ cartItem.cartComment } classes="text-sm" /> }

                    <div className="flex items-center mb-2">
                        {
                            itemPriceData.showMSRPPrice &&
                            <div className="mr-10" data-qa="cart-step1-product-full-price">
                                <s>
                                    <ProductPriceFormat price={ cartItem.skU_MSRP } />
                                </s>
                            </div>
                        }
                        { itemPriceData.discount > 0 && <div><ProductPriceFormat price={ itemPriceData.price } /></div> }
                    </div>

                    <CartItemPromos cartItem={ cartItem } classes="text-sm" />

                    <div className="flex items-center mt-4">
                        <Quantity cartItem={ cartItem } classes="flex items-start justify-center text-center" />

                        <div className="text-right mx-6">
                            {
                                itemPriceData.discount > 0 &&
                                <div className="font-bold text-green" data-qa="cart-step1-product-discount">-<ProductPriceFormat price={ itemPriceData.discount }/></div>
                            }

                            <div className="font-bold text-gray-700 text-lg" data-qa="cart-step1-product-discount-price"><ProductPriceFormat price={ itemPriceData.priceAfterDiscount } /></div>
                        </div>
                    </div>
                </div>

            </div>

            {
                !props.isLastItem &&
                <div className="border-b flex mx-4" style={{
                    height: '1px'
                }} />
            }
        </>
    )
};

export default Step1CartItemMobile;